import type { ReplyDraftStatus, ReplyDraftSummary } from './types';

/**
 * Statuses in which `.draft` is offered. A `preparing` draft has no card yet
 * and a `failed` one never will, so neither is worth opening.
 */
const OFFERED_STATUSES: ReadonlySet<ReplyDraftStatus> = new Set([
  'ready',
  'drafting',
  'handed_off',
]);

export function isOfferedStatus(status: ReplyDraftStatus): boolean {
  return OFFERED_STATUSES.has(status);
}

/** The draft `.draft` opens in a conversation, if any. */
export function findOfferedDraft(
  drafts: ReplyDraftSummary[],
  conversationId: string
): ReplyDraftSummary | undefined {
  return drafts.find(
    (draft) => draft.conversationId === conversationId && isOfferedStatus(draft.status)
  );
}
